import { h } from "preact";
import { RoutableProps } from "preact-router";
import { OrderCreator } from "../../../components/OrderCreator";
import { meissaOT } from "../../../data/serialNumberSearchExecs";
import "./styles.scss";

export function MeissaOTOrder(props: RoutableProps & { id?: string }) {
    return <div class="mezos-sit-order-page">
        <OrderCreator id={props.id} orderTypes={meissaOT.orderTypes} serialRegexes={meissaOT.orderedExecs}/>
    </div>;
}
